export const PositionOptions = {
    TOP: "TOP",
    BOTTOM: "BOTTOM",
}

export const PositionOptionsMessageKey = {
    TOP: "positionOptions.top",
    BOTTOM: "positionOptions.bottom",
}